import { render, staticRenderFns } from "./salaryModal.vue?vue&type=template&id=3c47dca2&"
import script from "./salaryModal.vue?vue&type=script&lang=js&"
export * from "./salaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports